import { QueryClient } from '@tanstack/react-query';
import { api } from '../api/client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,      // 5 Minuten - Daten gelten als frisch
      gcTime: 30 * 60 * 1000,        // 30 Minuten - Cache-Lebensdauer
      refetchOnWindowFocus: false,   // Kein automatischer Refetch bei Tab-Wechsel
      retry: 1,                      // Nur 1 Retry bei Fehlern
    },
  },
});

// V-1659: Abmelden, Benutzer- und Mandantenwechsel leeren den Query-Cache (kein Datenrest am geteilten PC)
api.onAuthWechsel(() => queryClient.clear());
